// from: https://medium.com/@Taha_Shashtari/the-easy-way-to-change-page-title-in-vue-6caf05006863
/**
 *
 * More things to implement:
 * https://vueuse.org/core/useTitle/ — dynamic
 * https://stackoverflow.com/questions/51639850/how-to-change-page-titles-when-using-vue-router - router level
 * (but current solution is better because you get to manage it straight from the component, otherwise you might
 * forget you have this set up in the router)
 */

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}
export default {
  created() {
    const title = getTitle(this);
    if (title) {
      document.title = title;
    }
  },
};
